import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-28ea6d5e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src", "alt"]

import { computed, ref } from 'vue';
import generateSrc from '@/core/responsive/image/helpers/generate-src';
import { IExtendedImageOptions } from '@/core/responsive/image/image.types';
import { imageNotFound } from '@/core/responsive/image/helpers/image-not-found.constant';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductImageZoom',
  props: {
    sku: {
        type: String,
        required: true,
    },
    alt: {
        type: String,
        required: false,
        default: '',
    },
    isZooming: {
        type: Boolean,
        required: false,
        default: false,
    },
    aspectRatioForOverlay: {
        type: Number,
        required: false,
        default: 16 / 9,
    },
    breakpointsState: {
        type: String,
        required: false,
        default: 'xs',
    },
    cacheBust: {
        type: [String, Number],
        required: false,
        default: '1',
    },
},
  setup(__props) {

const props = __props



const loadEventFired = ref(false);
const errorEventFired = ref(false);

const handleLoad = (): void => {
    loadEventFired.value = true;
};

const handleError = (): void => {
    errorEventFired.value = true;
};

const sizes = {
    xs: 320,
    sm: 640,
    md: 640,
    lg: 1024,
    xl: 1600,
    xxl: 1600,
};

const scaleLevel = computed(() => {
    if (props.breakpointsState === 'xs' || props.breakpointsState === 'sm') {
        if (props.isZooming) {
            return 4;
        } else {
            return 2;
        }
    }

    return props.isZooming ? 2.5 : 1;
});

const getProductImageZoomSrc = computed(() => {
    const currentWidth = sizes[props.breakpointsState];
    const width = currentWidth * scaleLevel.value;
    const url = `/products/${props.sku}.webp`;
    const imageOptions: Partial<IExtendedImageOptions> = {
        fit: 'pad',
        width,
        aspectRatio: props.aspectRatioForOverlay,
        background: 'transparent',
        isProductImage: true,
        cacheBust: props.cacheBust,
    };

    return generateSrc(url, imageOptions);
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("img", {
    src: errorEventFired.value ? _unref(imageNotFound) : _unref(getProductImageZoomSrc) ,
    alt: __props.alt,
    class: _normalizeClass(["responsive-aspect-ratio", {'responsive-aspect-ratio--loaded': loadEventFired.value, 'c-on-error': errorEventFired.value}]),
    onError: handleError,
    onLoad: handleLoad
  }, null, 42, _hoisted_1))
}
}

})